import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { isPositiveInteger, hexToRgb, rgbToHex } from '../utils/General';
import Select from './select';
import InputText from './input-text';


const RGB = 'RGB';
const HEX = 'HEX';
const DEBOUNCE_TIME = 500;

const colorOptions = [
  {
    title: HEX,
    value: HEX,
  },
  {
    title: RGB,
    value: RGB,
  },
];


class ColorInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mod: RGB,
      tempColor: props.value,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ tempColor: this.props.value });
    }
  }

  changeMod = (value) => {
    this.setState({
      mod: value,
    });
  };

  handleColorChange = (e) => {
    this.setState({ tempColor: e.target.value });
  };

  handleColorBlur = () => {
    const { handleChange } = this.props;
    handleChange(this.state.tempColor);
  };

  render() {
    const { mod, tempColor } = this.state;
    const { value, handleChange } = this.props;
    const ColorValueInput = mod === RGB ? RGBInput : HEXInput;

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Select
                options={colorOptions}
                wrapperStyles={{ width: '70px' }}
                height={32}
                selected={mod}
                handleSelect={this.changeMod}
            />
            <div style={{ width: '10px' }} />
            <ColorValueInput value={value} handleChange={handleChange} />
            <div style={{ width: '10px' }} />
            <input
                type="color"
                value={tempColor}
                onChange={this.handleColorChange}
                onBlur={this.handleColorBlur}
                style={{
                  width: '40px',
                  height: '32px',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                }}
            />
          </div>
        </div>
    );
  }
}

ColorInput.propTypes = {
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

class HEXInput extends Component {
  validate=(value) => {
    const isValid = /^#(\d|[A-F]){6}$/i.test(value);
    if (!isValid) {
      throw new Error('Wrong Format');
    }
  };

  render() {
    const { handleChange, value } = this.props;
    return (<InputText inputStyles={{ width: '175px' }} validate={this.validate} debounceTime={DEBOUNCE_TIME} handleChange={handleChange} defaultValue={value} />);
  }
}

HEXInput.propTypes = {
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

class RGBInput extends Component {
  constructor(props) {
    super(props);
    const { value } = props;
    const valueInRgb = hexToRgb(value);
    this.state = {
      r: valueInRgb.r,
      g: valueInRgb.g,
      b: valueInRgb.b,
    };
  }

  validate=(value) => {
    isPositiveInteger(value);
    const parsedValue = Number(value);
    if (parsedValue < 0 || parsedValue > 255) {
      throw new Error('Wrong Range');
    }
  };

  handleChange=color => (value) => {
    const { handleChange, value: prevValue } = this.props;
    const prevValueInRgb = hexToRgb(prevValue);
    const parsedValue = Number(value);
    prevValueInRgb[color] = parsedValue;
    const valueInHex = rgbToHex(prevValueInRgb.r, prevValueInRgb.g, prevValueInRgb.b);
    handleChange(valueInHex);
  };

  render() {
    const { r, g, b } = this.state;
    return (
      <div style={{ display: 'flex' }}>
        <InputText inputStyles={{ width: '65px' }} validate={this.validate} maxLength={3} handleChange={this.handleChange('r')} debounceTime={DEBOUNCE_TIME} defaultValue={r} />
        <div style={{ width: '5px' }} />
        <InputText inputStyles={{ width: '65px' }} validate={this.validate} maxLength={3} handleChange={this.handleChange('g')} debounceTime={DEBOUNCE_TIME} defaultValue={g} />
        <div style={{ width: '5px' }} />
        <InputText inputStyles={{ width: '65px' }} validate={this.validate} maxLength={3} handleChange={this.handleChange('b')} debounceTime={DEBOUNCE_TIME} defaultValue={b} />
      </div>
    );
  }
}

RGBInput.propTypes = {
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ColorInput;



// WEBPACK FOOTER //
// ./src/components/ColorInput.jsx